import React from 'react';
import { DESTINATION_OPTIONS, type VendorInvoiceDestination } from '../../lib/vendorInvoiceDestinationApi';

/**
 * The destination choice (D95): Ship Chandlery, Company expense, and Pantry shown
 * disabled ("on hold"), so it can never be picked or sent. Used by the upload
 * dialog and the review header.
 */
export interface DestinationPickerProps {
  value: VendorInvoiceDestination;
  onChange: (next: VendorInvoiceDestination) => void;
  disabled?: boolean;
  id: string;
}

const DestinationPicker: React.FC<DestinationPickerProps> = ({ value, onChange, disabled = false, id }) => (
  <select
    id={id}
    aria-label="Destination"
    value={value}
    disabled={disabled}
    onChange={(e) => onChange(e.target.value as VendorInvoiceDestination)}
    className="w-full px-3 py-2 rounded-lg bg-white border border-slate-200 text-slate-700 text-sm outline-none disabled:opacity-60"
  >
    {DESTINATION_OPTIONS.map((o) => (
      <option key={o.value} value={o.value} disabled={o.disabled}>
        {o.label}
      </option>
    ))}
  </select>
);

export default DestinationPicker;
